import React, { useEffect, useState } from "react";
import { X, Share, PlusSquare, Download } from "lucide-react";

const DISMISS_KEY = "cx-pwa-dismissed";

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [mode, setMode] = useState(null); // "native" | "ios"

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
      if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) return;
      const ua = navigator.userAgent;
      const isIos = /iphone|ipad|ipod/i.test(ua);
      const isIosSafari = isIos && !/crios|fxios|edgios/i.test(ua);
      const onBip = (e) => { e.preventDefault(); setDeferred(e); setMode("native"); };
      window.addEventListener("beforeinstallprompt", onBip);
      let t;
      if (isIosSafari) t = setTimeout(() => setMode("ios"), 2500);
      return () => { window.removeEventListener("beforeinstallprompt", onBip); clearTimeout(t); };
    } catch { /* private mode etc. */ }
  }, []);

  if (!mode) return null;

  const dismiss = () => {
    setMode(null);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch {}
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch {}
    dismiss();
  };

  return (
    <div className="sm:hidden fixed bottom-5 left-4 right-24 z-[60] animate-in slide-in-from-bottom-4 fade-in duration-300" data-testid="pwa-install-prompt">
      <div className="flex items-center gap-3 rounded-2xl bg-[#0B1220] border border-white/10 shadow-2xl shadow-black/40 p-3 text-white">
        <img src="/pwa/icon-192.png" alt="" className="size-9 rounded-xl border border-white/10 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-[12.5px] font-semibold leading-tight">Install the Connexis app</div>
          {mode === "ios" ? (
            <div className="mt-0.5 text-[10.5px] text-white/50 leading-snug flex items-center gap-1 flex-wrap">
              Tap <Share className="size-3 inline text-[#7da9ff]" /> then <PlusSquare className="size-3 inline text-[#7da9ff]" /> “Add to Home Screen”
            </div>
          ) : (
            <div className="mt-0.5 text-[10.5px] text-white/50 leading-snug">One tap from your home screen — no app store needed.</div>
          )}
        </div>
        {mode === "native" && (
          <button onClick={install} className="shrink-0 inline-flex items-center gap-1 rounded-full bg-[#0055FF] hover:bg-[#0044CC] px-3 h-8 text-[11.5px] font-semibold" data-testid="pwa-install-btn">
            <Download className="size-3" /> Install
          </button>
        )}
        <button onClick={dismiss} className="shrink-0 grid place-items-center size-7 rounded-full text-white/40 hover:text-white hover:bg-white/10" data-testid="pwa-install-dismiss" aria-label="Dismiss">
          <X className="size-3.5" />
        </button>
      </div>
    </div>
  );
}
